






























































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { RobotOption, TwitterCardOption } from '@/models/MetaTags';
import { getLocalesString, Locale, findLocale, locales } from '@/models/Locale';
import { Guid } from 'guid-typescript';

import { BusyObject, BusyList } from '@/models/Busy';
import { AgentExecutionFrequency } from '@/models/AgentExecutionFrequency';
import { Monitoring, MonitoringsService, Brand, BrandsService, BrandQueriesService, BrandQueryResult, BrandQuerySession, BrandIndexItem, BrandQueryResultItem, BrandQueryHistoryItem, BrandQueryHistoryService, User, BrandIndexService, BrandQuerySettings } from '@/api/braendz';

import LoadingView from '@/components/Spinner/LoadingView.vue';
import DashboardCard from '@/components/Dashboard/DashboardCard.vue';
import VerticalBrandTile from '@/components/Brands/VerticalBrandTile.vue';
import RadialBar from '@/components/Statistics/RadialBar.vue';
import Counter from '@/components/Statistics/Counter.vue';
import BrandDetailsButton from '@/components/Brands/BrandDetailsButton.vue';
import BookmarkBrandButton from '@/components/BrandBookmarks/BookmarkBrandButton.vue';
import MonitorBrandButton from '@/components/Monitoring/MonitorBrandButton.vue';
import ThumbsButtons from '@/components/Feedback/ThumbsButtons.vue';
import VerticalBrandTileGrid from '@/components/Brands/VerticalBrandTileGrid.vue';
import Carousel3dSlider from '@/components/Carousels/Carousel3dSlider.vue';
import Label from '@/components/Label.vue';
import { BrandStateCategory, FilterableField, Comparator, SearchableField } from '@/models/Query';

@Component({
  components: {
    LoadingView,
    DashboardCard,
    VerticalBrandTile,
    RadialBar,
    Counter,
    ThumbsButtons,
    VerticalBrandTileGrid,
    Carousel3dSlider,
    BrandDetailsButton,
    BookmarkBrandButton,
    MonitorBrandButton,
    Label
  },
  metaInfo() {
    return {
      title: this.$i18n.t("monitorBrand.title").toString(),
      meta: [
        { name: 'robots', content: [RobotOption.NoIndex, RobotOption.NoFollow].join(',') },

        // Open Graph: Facebook, Instagram, WhatsApp, LinkedIn, Xing, Twitter:
        { property: 'og:type', content: "website" },
        { property: 'og:title', content: this.$i18n.t("monitorBrand.metaTags.title").toString() },
        { property: 'og:description', content: this.$i18n.t("monitorBrand.metaTags.description").toString() },
        { property: 'og:image', content: `${window.location.origin}${require('@/assets/logos/braendz-logo-tm-blue.png')}` },
        { property: 'og:locale', content: this.$i18n.locale },
        { property: 'og:locale:alternate', content: getLocalesString(',') },
        { property: 'og:site_name', content: this.$i18n.t("metaTags.title").toString()},

        // Twitter:
        { property: 'twitter:card', content: TwitterCardOption.SummaryLargeImage },
        { property: 'twitter:site', content: `@${process.env.VUE_APP_TWITTER_ACCOUNT}` }
      ]
    };
  }
})
export default class Dashboard extends Vue {
    // Private Members:
    private m_activeSubView: 'dashboard' | 'review' | 'settings' | 'results' | BrandQueryHistoryItem = 'dashboard';
    private m_settingsMailingTo: string | null = null;
    private m_currentReviewBrandIndex = 0;

    // Common Data Objects:
    public monitoring = new BusyObject<Monitoring>();
    public monitoredBrand = new BusyObject<Brand>();

    // Current Query Result
    public brandQueryResult = new BusyObject<BrandQueryResult>();
    public brandQueryResultKey: string = Guid.EMPTY;

    // Review
    public excludedBrands = new BusyList<BusyObject<BrandIndexItem>>();

    // History
    public historyItems = new BusyList<BrandQueryHistoryItem>();
    public selectedHistoryBrandQueryResult = new BusyObject<BrandQueryResult>();

    // Settings Form
    public isSettingsFormValid = true;
    public selectedSettingsTab = 0;
    public settingsName: string | null = null;
    public settingsDescription: string | null = null;
    public settingsExecutionFrequency: AgentExecutionFrequency | null = null;
    public settingsMailingEnabled = false;
    public settingsMailingCc: string[] = [];
    public settingsMailingCcListItems: string[] = [];
    public settingsMailingCulture: Locale | null = null;
    public settingsMailingOnlyOnChange = false;
    public settingsResultSize = 10;
    public settingsResultSizes = [ 10, 25, 50 ];
    public settingsSearchOnlyNewBrands = false;
    public settingsMinNameSimilarityScore = 0.7;
    public settingsMinLogoSimilarityScore = 0.9;

    public navigationVisible = true;

    public riskColors = [
        { color: '#269926', limit: 9.09 },
        { color: '#59AB20', limit: 18.18 },
        { color: '#8BBF1B', limit: 27.27 },
        { color: '#BDD317', limit: 36.36 },
        { color: '#E0E611', limit: 45.45 },
        { color: '#FFC107', limit: 54.54 },
        { color: '#F29E27', limit: 63.63 },
        { color: '#E67C37', limit: 72.72 },
        { color: '#D95940', limit: 81.81 },
        { color: '#CE3440', limit: 90.90 },
        { color: '#DB0000', limit: 100 }
    ];

    public selectedBrandsView: 'carousel-view' | 'vertical-view' = this.$vuetify.breakpoint.mdAndUp ? 'carousel-view' : 'vertical-view';

    // Properties:
    @Prop({ required: true }) 
    public id!: string;

    // Getter:
    public get isInitializing(): boolean {
        return this.$store.state.activeSubscription.isBusy || (this.monitoring.isBusy && this.monitoring.reason === 'Loading');
    }

    public get activeSubView(): 'dashboard' | 'review' | 'settings' | 'results' | BrandQueryHistoryItem {
        return this.m_activeSubView;
    }
    public set activeSubView(value: 'dashboard' | 'review' | 'settings' | 'results' | BrandQueryHistoryItem) {
        if(!value) return;

        this.m_activeSubView = value;

        if(typeof value !== 'string' && "id" in value) {
            this.loadHistoryBrandQueryResult(value);
        }
        else {
            this.loadHistoryBrandQueryResult(null);
        }
    }

    public get collapsableNavigation(): boolean {
        return this.$vuetify.breakpoint.mdAndDown;
    }

    public get showNavigation(): boolean {
        return !this.collapsableNavigation || this.navigationVisible;
    }
    public set showNavigation(value: boolean) {
        this.navigationVisible = value;
    }

    public get selectedBrandQueryHistoryItem(): BrandQueryHistoryItem | null {
        if(typeof this.activeSubView === 'string') return null;
        else if("id" in this.activeSubView) return this.activeSubView;
        else return null;
    }

    public get brandQuerySettings(): BrandQuerySettings | null | undefined {
        return this.monitoring.object?.settings;
    }

    public get visibleBrandQueryResultItems(): BrandQueryResultItem[] | undefined | null {
        return this.brandQueryResult.object?.items?.filter(b => {
            return b.deltaType !== 'Removed';
        });
    }

    public get removedBrandQueryResultItems(): BrandQueryResultItem[] | undefined | null {
        return this.brandQueryResult.object?.items?.filter(b => {
            return b.deltaType === 'Removed';
        });
    }

    public get currentReviewBrandIndex(): number {
        return this.m_currentReviewBrandIndex;
    }
    public set currentReviewBrandIndex(value: number) {
        const visibleResults = this.visibleBrandQueryResultItems ?? [];

        if(value >= 0 && value < visibleResults.length) this.m_currentReviewBrandIndex = value;
        else this.m_currentReviewBrandIndex = visibleResults.length - 1;
    }

    public get currentReviewBrand(): BrandQueryResultItem | null {
        const visibleResults = this.visibleBrandQueryResultItems ?? [];
        if(this.currentReviewBrandIndex >= 0 && visibleResults.length > this.currentReviewBrandIndex) {
            return visibleResults[this.currentReviewBrandIndex];
        } else {
            return null;
        }
    }

    public get locales(): Locale[] {
      return locales;
    }

    public get userMailAddress(): string | null {
        return (this.$store.state.user as BusyObject<User>)?.object?.mailAddress ?? null;
    }

    public get settingsMailingTo(): string | null {
        return this.m_settingsMailingTo ?? this.userMailAddress;
    }
    public set settingsMailingTo(value: string | null) {
        this.m_settingsMailingTo = value;
    }

    // Watchers & Event Handlers:

    // Component Lifecycle
    public mounted() {
        this.init();
    }

    // Methods
    public async init() {

        // Load history items:
        this.historyItems.load(async () => {
            if(!this.id) return null;
            else return await BrandQueryHistoryService.getBrandQueryHistory(this.id, 30);
        });

        // Load monitoring:
        const monitoring = await this.monitoring.load(async () => {
            if(!this.id) return null;
            else return await MonitoringsService.getMonitoring(this.id);
        });

        // Refresh the settings
        this.refreshSettings();

        // Load monitored brand:
        this.monitoredBrand.load(async () => {
            if(!monitoring?.brandId) return null;
            else return await BrandsService.getBrand(monitoring.brandId);
        });

        // Load brand query result:
        this.brandQueryResult.create(async () => {
            const result = !monitoring?.id || !monitoring?.settings?.query
                ? null
                : await BrandQueriesService.executeBrandQueryById(monitoring.id, { storeResult: false });
            this.brandQueryResultKey = Guid.create().toString();
            return result;
        });

        // Load excluded brands:
        this.excludedBrands.load(async () => {
            if(!monitoring?.settings?.query?.excludedIds) return null;

            const result: BusyObject<BrandIndexItem>[] = [];
            for(const id of monitoring.settings.query.excludedIds) {
                const excludedBrand = new BusyObject<BrandIndexItem>();
                result.push(excludedBrand);
                excludedBrand.load(async () => {
                    return await BrandIndexService.getIndexItem(id);
                });
            }
            return result;
        });
    }

    public async loadHistoryBrandQueryResult(item: BrandQueryHistoryItem | null) {
        await this.selectedHistoryBrandQueryResult.load(async () => {
            if(!item?.id) {
                return null;
            }
            return await BrandQueriesService.getBrandQueryHistoryItemResult(item.id);
        });
    }

    public buildKey(item: string | BrandQueryHistoryItem, index?: number): string {
        const suffix = index !== undefined ? `_${index}` : '';
        if(typeof item === 'string') return `${item}${suffix}`;
        else if("id" in item) return `BrandQueryHistoryItem_${item.id}${suffix}`;
        else return `Unknown_${suffix}`;
    }

    public async excludeBrand(brand: BrandQueryResultItem | BrandIndexItem | null | undefined) {
        await this.monitoring.update(async () => {
            // Get current monitoring data:
            const monitoring = this.monitoring.object;
            if(!monitoring || !monitoring.id || !monitoring.settings?.query) return monitoring;
            
            // Get brand IndexItem from parameter:
            const indexItem = !brand ? null : "indexItem" in brand ? brand.indexItem : brand as BrandIndexItem;
            if(!indexItem) return monitoring;

            // Get index-id from brand index:
            const id = indexItem?.id;
            if(!id) return monitoring;

            try {
                // Try to remove the excluded item from the result list:
                const brandQueryResultIndex = this.brandQueryResult.object?.items?.findIndex(e => e.indexItem?.id === id);
                if(brandQueryResultIndex !== undefined && brandQueryResultIndex !== -1) {
                    this.brandQueryResult.object?.items?.splice(brandQueryResultIndex, 1);
                }

                // Add brand to excluded list if not already available:
                if(!this.excludedBrands.list.find(e => e.object?.id === id)) {
                    this.excludedBrands.list.push(new BusyObject<BrandIndexItem>(indexItem));
                }

                // Get excluded IDs:
                const excludedIds = this.excludedBrands.list
                    .map(e => e.object?.id)
                    .filter(id => !!id) as string[];

                // Update monitoring:
                monitoring.settings.query.excludedIds = excludedIds;
                monitoring.settings = await BrandQueriesService.updateBrandQuerySettings(monitoring.id, monitoring.settings);

                return monitoring;

            } catch(error) {
                // Remove brand from excluded list:
                const excludedIndex = this.excludedBrands.list.findIndex(e => e.object?.id === id);
                if(excludedIndex !== -1) {
                    this.excludedBrands.list.splice(excludedIndex, 1);
                }

                if(brand && !("indexItem" in brand) && this.brandQueryResult.object?.items?.length !== undefined && !this.brandQueryResult.object.items.find(e => e.indexItem?.id === id)) {
                    const resultItem = !brand ? null : "indexItem" in brand ? null : brand as BrandQueryResultItem;
                    if(resultItem) this.brandQueryResult.object.items.push(resultItem);
                }

                throw error;
            }
        });
    }

    public async includeBrand(brand: BrandQueryResultItem | BrandIndexItem | null | undefined) {
        await this.monitoring.update(async () => {
            // Get current monitoring data:
            const monitoring = this.monitoring.object;
            if(!monitoring || !monitoring.id || !monitoring.settings?.query) return monitoring;
            
            // Get brand IndexItem from parameter:
            const indexItem = !brand ? null : "indexItem" in brand ? brand.indexItem : brand as BrandIndexItem;
            if(!indexItem) return monitoring;

            // Get index-id from brand index:
            const id = indexItem?.id;
            if(!id) return monitoring;

            try {
                // Remove brand from excluded list:
                const excludedIndex = this.excludedBrands.list.findIndex(e => e.object?.id === id);
                if(excludedIndex !== -1) {
                    this.excludedBrands.list.splice(excludedIndex, 1);
                }

                // Get excluded IDs:
                const excludedIds = this.excludedBrands.list
                    .map(e => e.object?.id)
                    .filter(id => !!id) as string[];

                // Update monitoring:
                monitoring.settings.query.excludedIds = excludedIds;
                monitoring.settings = await BrandQueriesService.updateBrandQuerySettings(monitoring.id, monitoring.settings);

                // Update the query result asynchronously:
                this.executeBrandQuery(false);

                return monitoring;

            } catch(error) {
                // Add brand again to excluded list
                if(!this.excludedBrands.list.find(e => e.object?.id === id)) {
                    this.excludedBrands.list.push(new BusyObject<BrandIndexItem>(indexItem));
                }
                throw error;
            }
        });
    }

    public async executeBrandQuery(storeResult: boolean) {
        await this.brandQueryResult.create(async () => {
            const monitoring = this.monitoring.object;
            const result = !monitoring?.id || !monitoring?.settings?.query
                ? null
                : await BrandQueriesService.executeBrandQueryById(monitoring.id, { storeResult: storeResult });
            this.brandQueryResultKey = Guid.create().toString();
            return result;
        });
    }

    public async refreshSettings() {
        if(!this.monitoring.object) return;

        this.settingsName = this.monitoring.object.name ?? null;
        this.settingsDescription = this.monitoring.object.description ?? null;
        this.settingsExecutionFrequency = this.monitoring.object.executionFrequency as AgentExecutionFrequency ?? null;
        this.settingsMailingEnabled = this.monitoring.object.mailingEnabled ?? false;
        this.settingsMailingCc = this.monitoring.object.mailingCc ?? [];
        this.settingsMailingCcListItems = [...this.settingsMailingCc];
        this.settingsMailingCulture = this.monitoring.object.mailingCulture
            ? findLocale(this.monitoring.object.mailingCulture) ?? null
            : null;
        this.settingsMailingOnlyOnChange = this.monitoring.object.mailingOnlyOnChange ?? false;

        this.settingsResultSize = this.monitoring.object.settings?.query?.limit ?? 10;        

        // Determine if only new brands are being searched
        const brandStateCategoryFilters = this.monitoring.object.settings?.query?.filters?.filter(
            f => f.field === FilterableField.BrandStateCategory
        ) ?? [];
        
        this.settingsSearchOnlyNewBrands = 
            brandStateCategoryFilters.length === 1 && 
            brandStateCategoryFilters[0].value === BrandStateCategory.New;

        this.settingsMinNameSimilarityScore = this.monitoring.object.settings?.query?.scoring?.minNameSimilarityScore ?? 0.7;
        this.settingsMinLogoSimilarityScore = this.monitoring.object.settings?.query?.scoring?.minLogoSimilarityScore ?? 0.9;
    }

    public async saveSettings() {
        await this.monitoring.update(async () => {
            const monitoring = this.monitoring.object;
            if(!monitoring || !monitoring.id || !monitoring.settings?.query) return monitoring;

            // Update basic settings
            monitoring.name = this.settingsName ?? null;
            monitoring.description = this.settingsDescription ?? null;
            monitoring.executionFrequency = this.settingsExecutionFrequency ?? null;
            monitoring.mailingEnabled = this.settingsMailingEnabled;
            monitoring.mailingTo = this.settingsMailingTo ?? null;
            monitoring.mailingCc = this.settingsMailingCc;
            monitoring.mailingCulture = this.settingsMailingCulture?.locale ?? null;
            monitoring.mailingOnlyOnChange = this.settingsMailingOnlyOnChange;

            // Update query settings - limit
            monitoring.settings.query.limit = this.settingsResultSize;

            // Update query settings - brand state category filter

            // Remove all existing BrandStateCategory filters
            monitoring.settings.query.filters = (monitoring.settings.query.filters ?? []).filter(
                f => f.field !== FilterableField.BrandStateCategory
            );

            // Add new BrandStateCategory filters based on settings
            if(this.settingsSearchOnlyNewBrands) {
                monitoring.settings.query.filters.push({
                    field: FilterableField.BrandStateCategory,
                    comparator: Comparator.Equals,
                    value: BrandStateCategory.New
                });
            } else {
                monitoring.settings.query.filters.push({
                    field: FilterableField.BrandStateCategory,
                    comparator: Comparator.Equals,
                    value: BrandStateCategory.New
                });
                monitoring.settings.query.filters.push({
                    field: FilterableField.BrandStateCategory,
                    comparator: Comparator.Equals,
                    value: BrandStateCategory.Alive
                });
            }

            // Update query settings - scoring
            if(!monitoring.settings.query.scoring) {
                monitoring.settings.query.scoring = {};
            }
            monitoring.settings.query.scoring.minNameSimilarityScore = this.settingsMinNameSimilarityScore;
            monitoring.settings.query.scoring.minLogoSimilarityScore = this.settingsMinLogoSimilarityScore;

            // Save monitoring settings
            return await MonitoringsService.upsertMonitoringCurrentUserDefaultAccount(monitoring);
        });

        // Refresh the settings:
        this.refreshSettings();

        // Update result:
        this.executeBrandQuery(false);
    }

    public async remove(monitoring: Monitoring) {
        await this.monitoring.delete(async () => {
            if (!monitoring.id) {
                return null;
            }
            await MonitoringsService.deleteMonitoring(monitoring.id);
            return monitoring;
        });
    }

    public removeCcItem(item: string) {
        if(!this.monitoring.object?.mailingCc) return;
        const itemIndex = this.monitoring.object.mailingCc.indexOf(item);
        if (itemIndex >= 0) this.monitoring.object.mailingCc.splice(itemIndex, 1);
    }

    public validateMailAddresses(values: []): true | string {
        return values.length <= 0 
            ? true 
            : !values.find(m => this.$validation.mail(m, '') !== true);
    }

    public countBrands(result: BrandQueryResult | null, type: 'None' | 'Added' | 'Changed' | 'Removed'): number {
        return result?.items?.filter(i => i.deltaType === type || (type === 'None' && !i.deltaType)).length ?? 0;
    }

    public isMonitoredBrand(brand: BrandQueryResultItem | null | undefined): boolean {
        return brand?.indexItem?.brandId === this.monitoring.object?.brandId;
    }
}
